import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { COUNTRY_FLAGS } from "@/lib/api";
import { motion } from "framer-motion";
import Calculator from "@/components/home/Calculator";

export default function Rates() {
  const [brands, setBrands] = useState([]);
  const [countries, setCountries] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/catalog/brands").then((r) => setBrands(r.data));
    api.get("/catalog/countries").then((r) => setCountries(r.data));
  }, []);

  const filtered = brands.filter((b) => b.name.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="min-h-screen bg-white" data-testid="rates-page">
      <section className="py-16 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-[#00C853] font-semibold">Live Rates</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#0B3C5D] mt-3 tracking-tight">
            Real-time rates, all brands.
          </h1>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto">
            Rates are updated continuously based on market demand. Use the calculator below for an
            instant quote, or browse the full rate table.
          </p>
        </div>
      </section>

      <Calculator compact />

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
            <h2 className="font-display text-2xl font-bold text-[#0B3C5D]">All rates</h2>
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search brand..."
              className="rounded-full border border-slate-200 px-5 py-2.5 text-sm bg-white focus:outline-none focus:border-[#0B3C5D] w-full sm:w-72"
              data-testid="rates-search"
            />
          </div>

          <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50">
                  <tr className="text-left">
                    <th className="px-6 py-3 font-medium text-slate-500">Brand</th>
                    <th className="px-6 py-3 font-medium text-slate-500">Category</th>
                    {countries.map((c) => (
                      <th key={c.code} className="px-6 py-3 font-medium text-slate-500 text-center">
                        {COUNTRY_FLAGS[c.code]} {c.code}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((b, idx) => (
                    <motion.tr
                      key={b.id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: Math.min(idx * 0.015, 0.4) }}
                      className="border-t border-slate-100 hover:bg-slate-50/60"
                      data-testid={`rates-row-${b.id}`}
                    >
                      <td className="px-6 py-4 font-medium text-[#0B3C5D]">{b.name}</td>
                      <td className="px-6 py-4 text-xs text-slate-500">{b.category}</td>
                      {countries.map((c) => (
                        <td key={c.code} className="px-6 py-4 text-center font-display font-bold text-[#00C853]">
                          {(b.rate[c.code] * 100).toFixed(1)}%
                        </td>
                      ))}
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
